const getTabID = element => element.getAttribute('data-tab-id')
const getTabHideClients = element => element.getAttribute('data-hide-clients')
const getContentByID = id => document.querySelector(`.mtt-cover-center--fairxchange [data-tab-content="${id}"]`)
const getTabByID = id => document.querySelector(`.mtt-cover-center--fairxchange [data-tab-id="${id}"]`)
const FAIRXCHANGE_MODEL = document.querySelector('.mtt-fairxchange-model')

function changeActiveContent (target) {
    const TAB_ID = getTabID(target)
    const SELECTED_CONTENT = getContentByID(TAB_ID)
    const ACTIVE_CONTENT = document.querySelector('.mtt-cover-center--fairxchange .active[data-tab-content]')

    ACTIVE_CONTENT.classList.remove('active')
    SELECTED_CONTENT.classList.add('active')
}

function changeActiveTab (target) {
    const TAB_ID = getTabID(target)
    const SELECTED_TAB = getTabByID(TAB_ID)
    const ACTIVE_TAB = document.querySelector('.mtt-cover-center--fairxchange .mtt-tab-button--active')

    ACTIVE_TAB.classList.remove('mtt-tab-button--active')
    SELECTED_TAB.classList.add('mtt-tab-button--active')
}

function toggleClients (target) {
    const HIDE_CLIENTS = parseInt(getTabHideClients(target))

    HIDE_CLIENTS === 1
        ? FAIRXCHANGE_MODEL.classList.add('mtt-fairxchange-model--hideClients')
        : FAIRXCHANGE_MODEL.classList.remove('mtt-fairxchange-model--hideClients')
}

function handleTabClick (event) {
    changeActiveContent(event.target)
    changeActiveTab(event.target)
    toggleClients(event.target)
}

export default function FairXchangeNavigation () {
    const TAB_BUTTONS = document.querySelectorAll('.mtt-cover-center--fairxchange .mtt-tab-button')
    TAB_BUTTONS.forEach(btn => btn.addEventListener('click', event => handleTabClick(event)))
}